<ng-container *ngIf="!env.USE_TAILWIND">
    <div class="dropdown-menu-item-wrapper">
        <a
            class="dropdown-menu-item-text"
            (click)="openClicked()"
            (keydown.enter)="openClicked()"
            (keydown.space)="openClicked()"
            role="button"
            tabindex="0"
            aria-haspopup="true"
            attr.aria-expanded="{{ isOpened }}">
            <mat-icon *ngIf="showIcon">language</mat-icon>
            {{ selected?.name }}
        </a>
        <div class="dropdown-menu-item arrow-top" [ngClass]="{ 'dropdown-menu-item__display': isOpened }">
            <p class="dropdown-menu-item__description">{{ 'LANGUAGE_WILL_CHANGE_UPON_SELECTION' | translate }}</p>
            <ul class="dropdown-menu-item__items">
                <li *ngFor="let language of languages">
                    <a
                        [attr.aria-current]="language.code === selected?.code"
                        [ngClass]="{ selected: language.code === selected?.code }"
                        (click)="selectLanguage($event, language)"
                        (keydown.enter)="selectLanguage($event, language)"
                        (keydown.space)="selectLanguage($event, language)"
                        tabindex="0"
                        >{{ language.name }}</a
                    >
                </li>
            </ul>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="env.USE_TAILWIND">
    <button
        class="pn-light:text-white flex items-center gap-x-1 border-none p-1"
        (click)="openClicked()"
        (keydown.enter)="openClicked()"
        (keydown.space)="openClicked()"
        tabindex="0"
        aria-haspopup="true"
        attr.aria-expanded="{{ isOpened }}">
        <span class="hu-light:text-white hidden dark:text-contrast-yellow lg:flex">
            <mat-icon class="text-[1rem]">language</mat-icon>
        </span>
        <span
            class="pn-light:text-white hu-light:text-white relative top-[1px] flex justify-start text-sm text-secondary dark:text-contrast-yellow"
            >{{ selected?.name }}</span
        >
        <span class="flex text-primary dark:text-contrast-yellow lg:hidden" [ngClass]="{ expanded: isOpened }">
            <mat-icon class="pn-light:text-white hu-light:text-white text-[1.5rem] text-secondary lg:hidden"
                >expand_more</mat-icon
            >
        </span>
    </button>

    <dialog class="relative" *ngIf="isOpened" [attr.open]="isOpened">
        <div
            class="arrow border[#d7d7d7] absolute z-50 ml-2 mt-2 w-40 min-w-full -translate-x-2/4 break-words rounded-md border border-solid bg-white px-4 py-5 after:absolute after:-top-2 after:left-[60%] after:border-8 after:border-b-8 after:border-t-0 after:border-solid after:border-transparent after:border-b-secondary after:content-[''] lg:w-56">
            <span class="mb-4 inline-block text-left text-sm dark:text-contrast-yellow">{{
                'LANGUAGE_WILL_CHANGE_UPON_SELECTION' | translate
            }}</span>
            <ul class="dropdown-menu-item__items">
                <li class="flex items-center" *ngFor="let language of languages">
                    <button
                        class="item w-full cursor-pointer border-none text-left text-sm text-secondary hover:underline dark:text-contrast-yellow"
                        [attr.aria-current]="language.code === selected?.code"
                        [ngClass]="{ underline: language.code === selected?.code }"
                        (click)="selectLanguage($event, language)"
                        (keydown.enter)="selectLanguage($event, language)"
                        (keydown.space)="selectLanguage($event, language)"
                        tabindex="0">
                        {{ language.name }}
                    </button>
                </li>
            </ul>
        </div>
    </dialog>
</ng-container>
